import { modals } from '@mantine/modals';

import { UTBReport } from './UTBReport';

export const reportModalManager = {
  openUTB: (batchId: string, title: string) =>
    modals.open({
      title,
      size: '80vw',
      styles: { body: { height: '80vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' } },
      children: <UTBReport batchId={batchId} />,
    }),
};
